import { render } from "./StarredEmail.vue?vue&type=template&id=821e0470&scoped=true"
import script from "./StarredEmail.vue?vue&type=script&lang=js"
export * from "./StarredEmail.vue?vue&type=script&lang=js"

import "./StarredEmail.vue?vue&type=style&index=0&id=821e0470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821e0470"]])

export default __exports__